<template>
    <div class="doc-section">
        <h1>Ver Ubicación Guardada</h1>
        <p>
            El sistema ofrece dos modalidades de visualización: una vista global para todos los puntos registrados y una
            vista individual para un punto específico.
        </p>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />


        <div v-if="plataforma === 'web'" class="platform-content">
            <h2>Visualización Global</h2>
            <p>Para gestionar la visibilidad de todos los marcadores simultáneamente:</p>

            <p>
                Hacer clic sobre el botón <strong>Mostrar ubicaciones</strong> para proyectar todas las ubicaciones registradas
                sobre el mapa.
            </p>
            <ol class="ul-contenedor">

                <li>Se mostrarán sobre el mapa todos los marcadores con las ubicaciones guardadas de forma masiva.</li>
                <li>Hacer clic sobre el botón <strong>Ocultar todos</strong> para limpiar el mapa y dejar de visualizar
                    las
                    ubicaciones.</li>
            </ol>

            <h2>Visualización Individual</h2>
            <p>Para localizar un solo punto y consultar su información detallada:</p>

            <ol class="ul-contenedor">
                <li>Hacer clic sobre el botón <strong>Ver</strong> (representado con el icono de un ojo) sobre la fila
                    de la
                    ubicación que desea visualizar.</li>
                <li>Se mostrará sobre el mapa el marcador con una ventana de globo mostrando la información descriptiva
                    del
                    punto.</li>
                <li>En la columna de acciones, el icono cambiará al botón <strong>Ocultar</strong> (representado con el
                    icono de un ojo tachado). Hacer clic sobre él para remover el marcador del mapa.</li>
            </ol>

            <div class="info-card">
                <p><strong>Nota de Privacidad:</strong></p>
                <ul class="ul-contenedor step-list">
                    <li>El <strong>Administrador</strong> podrá visualizar en la ventana de globo el nombre del usuario
                        que
                        registró la ubicación.</li>
                    <li>El <strong>Usuario final</strong> no visualizará este dato, ya que el sistema solo le permite
                        ver
                        sus propios registros.</li>
                </ul>
            </div>

            <h3>Referencia Visual</h3>
            <CarruselAciqui :items="imagenesVerUbicacion" />
        </div>

        <div v-if="plataforma === 'moviles'" class="platform-content">
            <h2>Visualización Global</h2>
            <p>Para gestionar la visibilidad de todos los marcadores simultáneamente:</p>

            <p>
                Hacer clic sobre el botón <strong>Mostrar ubicaciones</strong> para proyectar todas las ubicaciones registradas
                sobre el mapa.
            </p>
            <CarruselAciqui :items="[imagenesVerUbicacionMoviles[0]]" />
            <ol class="ul-contenedor">

                <li>Se mostrarán sobre el mapa todos los marcadores con las ubicaciones guardadas de forma masiva.
                    <CarruselAciqui :items="[imagenesVerUbicacionMoviles[1]]" />
                </li>
                <li>Hacer clic sobre el botón <strong>Ocultar ubicaciones</strong> para limpiar el mapa y dejar de visualizar
                    las ubicaciones.
                <CarruselAciqui :items="[imagenesVerUbicacionMoviles[2]]" />
                </li>
            </ol>


            <h2>Visualización Individual</h2>
            <p>Para localizar un solo punto y consultar su información detallada:</p>

            <ol class="ul-contenedor">
                <li>Hacer clic sobre el botón <strong>Ver</strong> (representado con el icono de un ojo) sobre la fila
                    de la ubicación que desea visualizar.
                <CarruselAciqui :items="[imagenesVerUbicacionMoviles[3]]" />
                </li>
                <li>Se mostrará sobre el mapa el marcador con una ventana de globo mostrando la información descriptiva
                    del punto.
                <CarruselAciqui :items="[imagenesVerUbicacionMoviles[4]]" />
                </li>
                <li>En la columna de acciones, el icono cambiará al botón <strong>Ocultar</strong> (representado con el
                    icono de un ojo tachado). Hacer clic sobre él para remover el marcador del mapa.
                <CarruselAciqui :items="[imagenesVerUbicacionMoviles[5]]" />
                </li>
            </ol>

            <div class="info-card">
                <p><strong>Nota de Privacidad:</strong></p>
                <ul class="ul-contenedor step-list">
                    <li>El <strong>Administrador</strong> podrá visualizar en la ventana de globo el nombre del usuario
                        que
                        registró la ubicación.</li>
                    <li>El <strong>Usuario final</strong> no visualizará este dato, ya que el sistema solo le permite
                        ver sus propios registros.</li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'VerUbicacion',
    components: { CarruselAciqui,plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesVerUbicacion: [
            {
                nombre: "Visualizar Ubicación",
                url: "img/ubicaciones/verUbicaciones.png",
                descripcion: "Marcadores proyectados en el mapa con su ventana de información."
            },
            {
                nombre: "Ocultar Ubicación",
                url: "img/ubicaciones/ocultarUbicacion.png",
                descripcion: "Cambio de estado del icono en la tabla de acciones."
            }
        ],
        imagenesVerUbicacionMoviles: [
            {
                nombre: "",
                url: "img/ubicaciones/moviles/btn_mostrarTodas_ubicaciones.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/ubicaciones/moviles/ver_todas_ubicaciones.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/ubicaciones/moviles/ocultar_ubicaciones.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/ubicaciones/moviles/ver_ubicacion_individual.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/ubicaciones/moviles/ubicacion_individual.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/ubicaciones/moviles/quitar_ubicacion.png",
                descripcion: ""
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>